export enum TreeNodeType {
  Source = "typeSourceNode",
  Group = "typeGroupNode",
  Device = "typeDeviceNode",
  ObjectNode = 'typeObjectNode',
  ArrayNode = 'typeArrayNode',
  Telemetry = "typeTelemetryNode",
  Unknown = "UNKNOWN"
}
